import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { debounce } from 'lodash';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { AgenciesService } from 'src/app/api/tourism/agencies.service';
import * as _ from 'underscore';
declare var $: any;

@Component({
  selector: 'component-search-agencies',
  templateUrl: './search-agencies.component.html',
  styleUrls: ['./search-agencies.component.css']
})
export class SearchAgenciesComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedAgenciesEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;

  data = [];
  keyword = 'fullname_str';
  isTypedSearch = false;
  classSearch: any;

  constructor(private agencyService: AgenciesService) {}

  ngOnInit() {
    this.classSearch = this.classSize;
  }

  debouncedSearchInput = debounce(event => this.getSearchTours(event), 250);

  getSearchTours(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_;
      this.agencyService.search(val_params).subscribe({
        next: (data: any) => {
          this.data = data.results;
          this.data.map(
            (item: any) =>
              (item.fullname_str = `${item.document_str} ${item.tradename}`)
          );
        }
      });
    } else {
      this.data = [];
    }
  }

  selectSearch(item: any) {
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);

    this.selectedAgenciesEvent.emit(item);
    this.data = [];
    this.searchInput.clear();
    this.searchInput.focus();
  }

  closedSearchPanel(): void {
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus();
  }
}
